import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { CommonModule } from '@angular/common';
import { IngresoAgendaVirtualComponent } from './ingreso-agenda/ingreso-agenda-virtual.component';
import { AgendaVirtualRouting } from './agenda-virtual-routing.module';
import { CancelarAgendaVirtualComponent } from './cancelar-agenda-virtual/cancelar-agenda-virtual.component';
import { SolicitarTurnoComponent } from './solicitar-turno/solicitar-turno.component';
import { AgendaVirtualComponent } from './agenda-virtual.component';
import { AgendaComponent } from './agenda/agenda.component';
import { RECAPTCHA_LANGUAGE, RecaptchaModule } from 'ng-recaptcha';
import { FullCalendarModule } from '@fullcalendar/angular';
import { ReprogramarTurnoComponent } from './reprogramar-turno/reprogramar-turno.component';

@NgModule({
    declarations: [
        AgendaComponent,
        AgendaVirtualComponent,
        CancelarAgendaVirtualComponent,
        IngresoAgendaVirtualComponent,
        SolicitarTurnoComponent,
        ReprogramarTurnoComponent
    ],
    imports: [
        FullCalendarModule,
        RecaptchaModule,
        AgendaVirtualRouting,
        SharedModule,
        CommonModule
    ],
    entryComponents: [AgendaComponent, ReprogramarTurnoComponent],
    providers: [
        {
            provide: RECAPTCHA_LANGUAGE,
            useValue: 'es-419',
        }
    ]
})

export class AgendaVirtualModule { }
